import React from 'react';
import { useWindowWidth } from '@utils/hooks';

const withWindowWidth = Component => props => (
  <Component screenWidth={useWindowWidth()} {...props} />
);

export default withWindowWidth;
